import { setLoading } from "../generalActions/mainActions";
import {addItem, changeListItem, reload, removeItem, setItems, setTableParams} from "../generalActions/listActions";
import { setForm, setItem } from "../generalActions/formActions";
import { wishlistService } from "../../../jwt/_services/todoFluye/wishlistService";

export const search = (pageIndex, pageSize, currentPage, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    wishlistService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return

            dispatch(setItems(result.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total, currentPage))
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = data => ( dispatch ) => {
    dispatch(setLoading(true))

    wishlistService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
            dispatch( reload() )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    wishlistService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
            dispatch( reload() )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const deleteItem = (id, fbDB) => ( dispatch ) => {
    dispatch(setLoading(true))

    wishlistService.deleteItem(id, fbDB)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const add = (data, callback = ()=>{}) => ( dispatch ) => {
    dispatch(setLoading(true))

     wishlistService.add(data)
        .then( result => {
            if(!result)
                return

            dispatch( changeListItem(result) )
            dispatch( reload() )
            callback()
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = data => ( dispatch ) => {
    dispatch(setLoading(true))

    wishlistService.remove(data)
        .then( result => {
            if(result?.status) {
                dispatch(changeListItem(result))
                dispatch( reload() )
            }
        })
        .finally(() => dispatch(setLoading(false)))
}